import http from "../http-common";

class TaxonomyService {
  getTaxonomyList() {
    return http.get("/taxonomy");
  }
}

export default new TaxonomyService();
